import React from 'react';
import DynamicComponent from '../../components/DynamicComponent/DynamicComponent';

export const CardsWrapper = blok => {
  // component that exist only to group Cards components in storyblok
  // in sb it is component with one field of type "block" and you are allowed to add only components from the list (set in sb)
  return <DynamicComponent {...blok.block[0]} />;
};
